<template>
  <v-card class="chatGift" flat>
    <v-row class="table-header">
      <v-col>禮物</v-col>
      <v-col>
        <div class="peach"></div>
        桃子
      </v-col>
      <v-col style="max-width: 300px"></v-col>
    </v-row>
    <template v-for="(gift, i) in gifts">
      <v-row class="align-center my-2">
        <template v-if="!gift.editing">
          <v-col>
            <v-img :src="gift.src" width="150" height="250"></v-img>
          </v-col>
          <v-col>
            <div>{{ gift.price }}</div>
          </v-col>
        </template>
        <template v-else>
          <v-col class="d-flex">
            <div 
              class="file-input" 
              @click="$refs[`image${i}`][0] ? $refs [`image${i}`][0].click() : ''"
            >
              <template v-if="gift.src">
                <v-icon class="delete" @click.stop="gift.src = ''; $forceUpdate()">fa-times-circle</v-icon>
                <v-img :src="gift.src" contain></v-img>
              </template>
              <template v-else>
                <input 
                  type="file" 
                  :ref="`image${i}`" 
                  :accept="$accept_file_type.image" 
                  onclick="this.value = null" 
                  @change="uploadImage(i)"
                />
                <div class="uploadText">
                  <v-icon>fa-plus</v-icon>
                  Select File
                </div>
              </template>
            </div>
          </v-col>
          <v-col>
           <v-textarea hide-details height="100" outlined v-model="gift.price" :rules="[$rules.integer]"></v-textarea>
          </v-col>
        </template>
    
        <v-col style="max-width: 300px">
          <v-btn icon color="indigo" class="mx-1" v-if="!gift.editing" @click="gift.editing = true">
            <v-icon>fa-edit</v-icon>
          </v-btn>
          <v-btn icon color="green" class="mx-1" v-else @click="save(i)">
            <v-icon>fa-save</v-icon>
          </v-btn>
          <DeleteConfirmBtn icon color="red" btnClass="mx-1" @delete="deleteGift(i)">
            <v-icon>fa-trash-alt</v-icon>
          </DeleteConfirmBtn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
    </template>
    <v-btn block class="pink mt-6" @click="addRow">
      <v-icon color="white">fa-plus</v-icon>
    </v-btn>
  </v-card>  
</template>

<script>
import DeleteConfirmBtn from '@/components/DeleteConfirmBtn'
export default {
  components: { DeleteConfirmBtn },
  data() {
    return {
      gifts: [],
    }
  },
  created() {
    this.getGifts()
  },
  methods: {
    async getGifts() {
      let response = await this.axios.get('/chat/gift')
      this.gifts = await Promise.all(response.data.map(async gift => {
        gift.file = await fetch(this.$HOST_URL + gift.image_path).then(r => r.blob())
        console.log(gift.file)
        gift.src = this.$HOST_URL + gift.image_path
        gift.editing = false
        return gift
      }))
    },
    async uploadImage(i) {
      let file = event.target.files[0]
      if(!await this.$func.fileValidation(file)) {
        return
      }
      this.gifts[i].file = file
      this.gifts[i].src = await this.$func.fileToBase64(file)
      this.$forceUpdate()
    },
    deleteGift(i) {
      this.axios.delete('/admin/chat/gift', {
        data: {
          ids: [this.gifts[i].id]
        }
      }).then(response => {
        this.$root.$emit('alert', 'success', '刪除成功')
        this.getGifts()
      }).catch(() => {
        this.$root.$emit('alert', 'success', '刪除失敗')
      })
    },
    addRow() {
      this.gifts.push({src: '', price: '', file: null, editing: true})
    },
    save(i) {
      if(!this.$rules.integer(this.gifts[i].price)) {
        return
      }
      if(this.gifts[i].src.startsWith('data:')) {
        this.add(i)
      }
      else {
        this.update(i)
      }
    },
    update(i) {
      let formData = new FormData()
      formData.append('image', this.gifts[i].file)
      formData.append('price', this.gifts[i].price)
      let config = {
        url: `/admin/chat/gift/${this.gifts[i].id}`,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        method: 'POST',
        data: formData,
      }
      this.axios(config).then(response => {
        this.$root.$emit('alert', 'success', '更新成功')
        this.getGifts()
      }).catch(() => {
        this.$root.$emit('alert', 'error', '更新失敗')
      })
    },
    add(i) {
      let formData = new FormData()
      formData.append('image', this.gifts[i].file)
      formData.append('price', this.gifts[i].price)
      let config = {
        url: '/admin/chat/gift',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        method: 'POST',
        data: formData,
      }
      this.axios(config).then(response => {
        this.$root.$emit('alert', 'success', '新增成功')
        this.getGifts()
      }).catch(() => {
        this.$root.$emit('alert', 'error', '新增失敗')
      })
    }
  }
}
</script>

<style lang="scss">
.chatGift {
  padding: 40px;
  .table-header {
    .col {
      max-width: unset;
      &:nth-child(2) {
        text-align: left;
      }
    }
  }
  .file-input {
    position: relative;
    margin-right: 0;
    width: 150px;
    height: 250px;
  }
}
</style>